import { PagedSearch } from '../../../shared/model/paged-search.model';

export class RegistrationSearchParams extends PagedSearch {
  public constructor() {
    super();

    this.Keyword = '';
    this.PageSize = 10;
    this.OrderBy = 'SignUpDate:desc';
    this.EventId = 0;
    this.SignUpStartDate = new Date();
    this.SignUpEndDate = new Date();
    this.AllUnpaid = false;
    this.AllWithBlankAttendees = false;
    this.AllWithProfileIdNotAssigned = false;
    this.EventItemIds = new Array<number>();
    this.InvoiceNumber = null;
  }

  public Keyword: string;
  public EventId: number;
  public SearchAnySignUpDate: boolean = true;
  public SignUpStartDate: Date;
  public SignUpEndDate: Date;
  public AllUnpaid: boolean;
  public AllWithBlankAttendees: boolean;
  public AllWithProfileIdNotAssigned: boolean;
  public EventItemIds: Array<number>;
  public InvoiceNumber: number;
}
